export default __webpack_public_path__ + "locales/si/Ldap.json?hash=b46b3d62b21ceb6028821418378e8f9a";